<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1 />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import MdinAddMain from '@/views/MouldManagement/MdinManage/TabChild/MdinAddMain';
export default {
  name: 'MdinAdd',
  components: {
    childTab1: MdinAddMain
  },
  data() {
    return {
      activeName: 'first'
    };
  }
};
</script>

<style scoped></style>
